<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <div class="pop-content-search">
        <el-form size="mini">
          <el-row :gutter="24">
            <el-col :span="4">
              <el-form-item label="신고자">
                <el-input v-model="form.custNm" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="연락처">
                <el-input v-model="form.telNo" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="요청일시">
                <el-input v-model="form.requestVisitDt" style="width: 100%;" readonly>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="접수일시">
                <el-input v-model="form.callDt" style="width: 100%;" readonly>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="처리일시">
                <el-input v-model="form.procDt" style="width: 100%;" readonly>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="4">
              <el-form-item label="고객구분">
                <el-row>
                  <el-col :span="24">
                    <el-col :span="25">
                      <el-select v-model="form.custType" disabled>
                        <el-option
                            v-for="item in custGbList"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="사이트명">
                <el-row>
                  <el-col :span="24">
                    <el-col :span="8">
                      <el-input type="text" v-model="form.siteNm1" readonly></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-input type="text" v-model="form.siteNm2" readonly></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-input type="text" v-model="form.siteNm3" readonly></el-input>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="주소">
                <el-row>
                  <el-col :span="24">
                    <el-col :span="3">
                      <el-input type="text" v-model="form.zipCd1" readonly></el-input>
                    </el-col>
                    <el-col :span="9">
                      <el-input type="text" v-model="form.addr1" readonly></el-input>
                    </el-col>
                    <el-col :span="9">
                      <el-input type="text" v-model="form.addr2" readonly></el-input>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="4">
              <el-form-item label="고객명">
                <el-input v-model="form.custNm" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="전화번호">
                <el-input v-model="form.telNo" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="핸드폰">
                <el-input v-model="form.hpNo" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="MA구분">
                <el-input v-model="form.maYn" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="유/무상">
                <el-input v-model="form.changePayYnNm" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="grid-wrap">
        <tabs :tab="tab" :active-btn="active" @changeTab="changeTab"/>
        <component ref="cmpReceptionModal" v-bind:is="viewer"  @loadTab="loadTab"/>
        <!--  -->
      </div>
    </div>
  </layout>
</template>

<script>
/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function _phone(hp){
  return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

/**
 * * components
 */
import Layout from '@/components/Slot/ModalSlot.vue';

/**
 * * Tab 구분 컴포넌트
 */
import tabs from '@/components/AS/Tabs/index.vue';
import procsHist from './ProcsHst';
import recptHst from './RecptHst';
import rstHst from './RstHst';

import rcpt from './index';

export default {
  mixins: [rcpt],
  props: {
    data: {
      Type: Array
      , required: false
    },
    custNo: {
      Type: String
      , required: false
    }
  },
  components: {Layout, tabs, procsHist, recptHst, rstHst},
  data() {
    return {
      title: '접수/처리상세내역',
      viewer: 'procsHist',
      active: true,
      tab:[
        {tabId: 'recptHst', tabName:'접수내역', tabCss:"btn btn-outline-primary", tabNo:'0'},/** 'btn btn-nonActive'버튼 비활성화 class */
        {tabId: 'procsHist', tabName:'처리내역', tabCss:"btn btn-primary", tabNo:'1'},
        {tabId: 'rstHst', tabName:'정산내역', tabCss:"btn btn-outline-primary", tabNo:'2'},
      ],
      custGbList: [{key: '1', value: '일반'}, {key: '2', value: 'VIP'}],
      form : {
        custCd: '01',
      },
      receptionParam: {}
    }
  },
  created() {

    this.$bus.$on('input', (val) => {
      // console.log('-> input bus on ', val);
    });
  },
  beforeMount() {
    this.getCustTypeCombo();
    console.log('beforeMount aaa data==', this.data);
    if(this.data.firstTab === 'INIT1' || this.data.firstTab === 'INIT3'){
      // Tab을 변경하면 => viewer 변경발생 => loadTab 함수가 호촐됨.
      if(this.data.firstTab === 'INIT1'){
        this.changeTab(this.tab[0]);
      } else {
        this.changeTab(this.tab[2]);
      }

    } else {
      this.goOpen('INIT', 0);
    }
  },
  mounted() {
    //pop slots modal move
    $(".animation-content").addClass('pop_min2');
    $(".animation-content").draggable({'cancel':'.modal-card-body'});
    //ModalSlot open z-index change
    $('.lnb').css('z-index', '4');



  },
  destroyed() {
    //ModalSlot open z-index change
    $('.lnb').css('z-index', '7');
  },
  methods: {
    changeTab(params) {
      console.log('changeTab params==', params, this.tab);
      this.viewer = params.tabId;

      this.tab[0].tabCss = 'btn btn-outline-primary';
      this.tab[1].tabCss = 'btn btn-outline-primary';
      this.tab[2].tabCss = 'btn btn-outline-primary';

      if(params.tabId === 'recptHst'){
        this.tab[0].tabCss = 'btn btn-primary';
      } else if(params.tabId === 'procsHist'){
        this.tab[1].tabCss = 'btn btn-primary';
      } else if(params.tabId === 'rstHst'){
        this.tab[2].tabCss = 'btn btn-primary';
      }
    },
    closeModal() {
      if( ['CallDisposeList', 'ApprovalList', 'CalculationListModal'].includes(this.data.menuGubun)){ // AS처리리스트, 승인처리리스트, 정산관리 팝업
        this.$parent.$parent.goOpen();
      }
      this.$parent.close();
    },
    getCustTypeCombo() {
      // 고객구분
      this.$http.get(`/api/codeMng/combo`, {params: {parentId: 10}})
          .then(response => {
            this.custGbList = response.data;
          });
    },
    goOpen(callFlag, param) {
      const vm = this
      vm.$store.commit('loading')

      let vInit = false
      let vAsDetailId = 0
      let vAsProcessId = 0
      if(callFlag === 'INIT' || callFlag === 'INIT1' || callFlag === 'INIT3'){
        vInit = true
      } else {
        vAsDetailId = param.asDetailId || 0
        vAsProcessId = param.asProcessId || 0
      }

      this.$http.post(_url("/api/asMng/popup/asRead"), {
        companyId: 'CENTERLINK', //this.$store.state.loginInfo.compCd,
        asId: this.form.asId,
        asDetailId: vAsDetailId,
        asProcessId: vAsProcessId,
        custId: this.form.custId,
        sortType: this.form.sortType || '',
        page: 1,
        totalpage: 9999,
        totalcount: 9999,
        curPage: 0,
        processTime: ''

      }).then(response => {
        console.log('response dddd 이상: ', response.data)
        if(response.data.callAsDetail){
          response.data.callAsDetail = response.data.callAsDetail.map(x => {
            x.guaranteeEndDt = x.guaranteeEndDt ? x.guaranteeEndDt.substring(0,10) : ''
            return x
          })
        }

        if(response.data.callAsFailureCause){
          response.data.callAsFailureCause = response.data.callAsFailureCause.map(x => {
            const arr1 = x.asFailureCauseCatFullNm.split('>')
            if(arr1.length >= 1){
              x.asFailureCauseCat1 = arr1[1]
            }

            return x
          })
        }

        if(response.data.callAsRepair){
          response.data.callAsRepair = response.data.callAsRepair.map(x => {
            if(x.asRepairCatFullNm){
              const arr1 = x.asRepairCatFullNm.split('>')
              if(arr1.length > 1){
                x.asRepairCat1 = arr1[1] || ''
              }

              if(arr1.length > 2){
                x.asRepairCat2 = arr1[2] || ''
              }

              if(arr1.length > 3){
                x.asRepairCat3 = arr1[3] || ''
              }
            }

            return x
          })
        }

        vm.receptionParam = response.data
        vm.receptionParam.asId = vm.data.asId
        vm.receptionParam.custId = vm.form.custId
        vm.receptionParam.sortType = vm.form.sortType
        vm.form = vm.data.popHeadInfo
        vm.form.asId = vm.data.asId
        if(response.data.callAsMstSelList){
          const asForm = response.data.callAsMstSelList[0];

          vm.form.custNm = asForm.custNm;
          vm.form.telNo = _phone(asForm.telNo);
          vm.form.hpNo = _phone(asForm.hpNo);
          vm.form.requestVisitDt = asForm.requestVisitDt && asForm.requestVisitDt.length>=16 ? asForm.requestVisitDt.substring(0,16) : '';
          vm.form.callDt = asForm.callDt && asForm.callDt.length>=16 ? asForm.callDt.substring(0,16) : '';
          vm.form.procDt = asForm.procDt && asForm.procDt.length>=16 ? asForm.procDt.substring(0,16) : '';
        }

        if(response.data.callCustSelItemList[0]){
          vm.form.custType = response.data.callCustSelItemList[0].custType;
          vm.form.zipCd1 = response.data.callCustSelItemList[0].zipCd;
          vm.form.addr1 = response.data.callCustSelItemList[0].addr1;
          vm.form.addr2 = response.data.callCustSelItemList[0].addr2;
          vm.form.siteNm1 = response.data.callCustSelItemList[0].siteNm1;
          vm.form.siteNm2 = response.data.callCustSelItemList[0].siteNm2;
          vm.form.siteNm3 = response.data.callCustSelItemList[0].siteNm3;
        }

        if(response.data.callAsProcessSel1List){
          vm.receptionParam.asProcessId = response.data.callAsProcessSel1List[0].asProcessId
          vm.receptionParam.asDetailId = response.data.callAsProcessSel1List[0].asDetailId
          vm.receptionParam.repairId = response.data.callAsProcessSel1List[0].repairId

          if(callFlag === 'INIT'){
            // 초기로딩시 디폴트로 처리내역이 활성화
            //vm.subLoadTab( {"tabNm":"2", "index": 0, asDetailId: vm.receptionParam.asDetailId, asProcessId: vm.receptionParam.asProcessId, repairId: vm.receptionParam.repairId} )
            vm.subLoadTab( {"tabNm":"2", "index": 0, asDetailId: vm.receptionParam.asDetailId, asProcessId: vm.receptionParam.asProcessId, repairId: vm.receptionParam.repairId} )
                .then(val => {
                  //this.$refs.cmpReceptionModal.repairFeeAmtCompute();
                })
          } else if(callFlag === 'INIT1'){
            // 초기로딩시 디폴트로 접수내역이 활성화
            vm.subLoadTab( {"tabNm":"1", "index": 0, asDetailId: vm.receptionParam.asDetailId, asProcessId: vm.receptionParam.asProcessId} )
          } else if(callFlag === 'INIT3'){
            // 초기로딩시 디폴트로 정산내역이 활성화
            vm.subLoadTab( {"tabNm":"3", "index": 0, asDetailId: vm.receptionParam.asDetailId, asProcessId: vm.receptionParam.asProcessId} )
          } else {
            param.asProcessId = vm.receptionParam.asProcessId;
            param.asDetailId = vm.receptionParam.asDetailId;
            vm.subLoadTab( param )
          }
        }
      }).finally(() => {
        vm.$store.commit('finish');
      });

    },
    subLoadTab(param) {
      console.log('subLoadTab =====start', param, this.receptionParam, this.$refs.cmpReceptionModal)

      this.receptionParam.asDetailId = param.asDetailId;
      this.receptionParam.asProcessId = param.asProcessId;

      if(this.receptionParam.asId) {
        const index = param.index || 0
        if(param.tabNm === "1"){  /** 접수내역 */
          this.$refs.cmpReceptionModal.data = this.receptionParam.callAsDetail.map(x=>{
              x.recptTp = (x.subAsClassNm==='유상수리') ? '01' : '02'; // 접수유형/세부유형
              
              return x;
            });
          this.$refs.cmpReceptionModal.changeRecpHstInfo(this.receptionParam, index);
          
        } else if(param.tabNm === "2"){ /** 처리내역 */
        this.$refs.cmpReceptionModal.data = this.receptionParam.callAsProcessSel1List
          this.$refs.cmpReceptionModal.changeProcsHstInfo(this.receptionParam, index)

        } else if(param.tabNm === "3"){ /** 정산내역 */
        this.$refs.cmpReceptionModal.data = this.receptionParam.callAsProcessSel1List
          this.$refs.cmpReceptionModal.changeRstHstInfo(this.receptionParam, index)

        }
      }
      return new Promise((resolve) => {
        return resolve(this.$refs.cmpReceptionModal.data);
      });
    },
    loadTab(param) {
      console.log('param', param)
      /**
       * 호출 CASE
       * 1. 서브탭인 접수내역, 처리내역탭에서 asDetailId, asProcessId을 클릭한 경우 재로딩(RELOAD 사용)
       * 2. 해피콜리스트 : 접수내역을 제일 먼저 표시하여야 함(firstTab 파라미터에 INIT1를 사용)
       *    beforeMount에서 Tab을 변경하면 => viewer 변경발생 => loadTab 함수가 호촐됨.
       */

      // if(this.data.firstTab === 'INIT1' || this.data.firstTab === 'INIT3'){
      //   this.goOpen(this.data.firstTab, param);
      //   this.data.firstTab = ''; // 초기화
      //
      // } else {
      //   this.goOpen('INIT', param);
      // }

      if(param.tabNm === '1'){
        this.goOpen(this.data.firstTab, param); // INIT1 접수내역
      } else if (param.tabNm === '2') {
        this.goOpen('INIT', param);   // 처리내역
      } else if (param.tabNm === '3') {
        this.goOpen('INIT3', param);  // 정산내역
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}
</style>